export default "__VITE_ASSET__CRxLsMhO__"